const OFFER_VARIANTS = {
  BASELINE: "baseline",
  PER_MONTH_PRICE: "perMonthPrice",
  FULL_PRICE: "fullPrice",
};

const FEATURE_FLAGS = {
  DISPLAY_APPLE_BUTTON: "display_apple_button",
  REMOVE_EMAIL_MORE_SOCIAL: "remove_email_more_social",
  SIDE_BY_SIDE_VS_TOTAL_PER_MONTH: "side_by_side_vs_total_per_month",
  CATEGORY_REDESIGN_CHRISTMAS: "category_redesign_christmas",
};

const CATEGORY_REDESIGN_CHRISTMAS_VARIANTS = {
  BASELINE: "baseline",
  NEW_CATEGORY_DESIGN_CHRISTMAS: "newCategoryDesignChristmas",
};

Object.freeze(FEATURE_FLAGS);
Object.freeze(OFFER_VARIANTS);
Object.freeze(CATEGORY_REDESIGN_CHRISTMAS_VARIANTS);

export { FEATURE_FLAGS, OFFER_VARIANTS, CATEGORY_REDESIGN_CHRISTMAS_VARIANTS };
